<div class="item-grid-container">
  <div class="search-holder">
  <ul class="list-inline grid-top-actions search-holder mb-3">
    <li class="list-inline-item">
      <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
    </li>
    <li class="list-inline-item">
      <div class="calendar-btn">
        <input
          matInput
          [matDatepicker]="dpFrom"
          disabled
          [min]="minFromDate"
          placeholder="MM/DD/YYYY"
          [max]="maxDate"
          (dateChange)="changeFromDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
        <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
      </div>
    </li>
    <li class="list-inline-item">
      <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
    </li>
    <li class="list-inline-item">
      <div class="calendar-btn">
        <input
          matInput
          [matDatepicker]="dpTo"
          disabled
          [min]="minToDate"
          placeholder="MM/DD/YYYY"
          [max]="maxDate"
          (dateChange)="changeToDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
        <mat-datepicker #dpTo disabled="false"></mat-datepicker>
      </div>
    </li>
    <li class="list-inline-item ">
      <input
        type="text"
        placeholder="{{ 'pages.newRetailer.search' | translate }}"
        matInput
        class="
          rounded-pill
          px-3
          py-2
          mb-0
          border-0
          bg-light
          w-100
          me-0
          input-search
          ms-3
        "
        (keyup)="quickSearch()"
        [(ngModel)]="searchValue"
      />
      <i
        color="primary"
        class="search-icon-holder"
        matSuffix
        mat-icon-button
        aria-label="Search"
      >
        <mat-icon>search</mat-icon>
      </i>
    </li>
    <li class="list-inline-item float-end">
      <button [disabled]="isButtonDisabled"  mat-stroked-button class="bg-theme ms-2" (click)="exportData()">
        <span translate class="translate">pages.newRetailer.download</span>
        <i class="mi mi-save-alt ms-2"></i>
      </button>
    </li>
  </ul>
  </div>
  <div class="stats-blks-holder mb-2" [ngStyle]="{'display': userRole === 'Customer Service' ? 'none' : 'block' }">
    <div class="row g-2">
      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
        <div class="card border-0 py-3 px-2 rounded bg-theme-light">
          <div class="row">
              <div class="sales-card">
                <h5 >
                  {{'pages.placeholders.TotalRecords' | translate}} <br /><span class="values">{{ NumberofRecord }}</span>
                </h5>
              </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-each-blk">
        <div class="card border-0 py-3 px-2 rounded bg-theme-light">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 stats-each-blk">
              <div class="profit-card">
                <h5 translate>
                  {{'pages.placeholders.TotalCreditLineamount' | translate }} <br /><span class="values">{{ Summary | currency }}
                   </span
                  >
                </h5>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="realtime-transactions-grid-container">
  <ag-grid-angular
    style="width: 100%; height: 65vh"
    class="ag-theme-material"
    id="historygrid"
    [rowHeight]="40"
    [enableFilter]="true"
    [enableSorting]="true"
    [enableColResize]="true"
    [rowSelection]="rowSelection"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
</div>
